import { AenderungsantragDisplayModel } from "@/api/model-index";
import { AenderungsantragService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class GetAllAenderungsantraegeResolver  {
    constructor(protected aenderungsantragService: AenderungsantragService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AenderungsantragDisplayModel[]> {
        let id: string = <string>route.params['id'];

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        if (this.portalContextService.Aenderungsantraege) {
            return this.portalContextService.Aenderungsantraege;
        }

        const antrage = await this.aenderungsantragService.apiAenderungsantragGetAllProjektIdGet({ projektId: id }).toPromise();

        this.portalContextService.Aenderungsantraege = antrage;

        return antrage;
    }
}